export default __webpack_public_path__ + "static/media/AKM_2.1865d1dc.png";